import * as THREE from 'three';

import { GLTFGroup } from '../lib/GLTFGroup';
import { ModelViewer } from '../lib/ModelViewer';
import { SceneDirectionalLight } from '../lights/SceneDirectionalLight';
import {SceneAmbientLight} from "../lights/SceneAmbientLight";

export type SceneParams = {
    tableAdVisible: boolean;
};

export class BasicStudioSceneGLTF extends GLTFGroup {
    private params: { tableAdVisible: boolean };

    constructor(viewer: ModelViewer, gltf, params: SceneParams) {
        super(viewer, gltf, 'BasicStudioSceneGLTF');

        this.params = params;
    }

    static loadAssets(viewer, lotterySlug: string, params: SceneParams) {
        const pathToAssets = viewer.getPathToAssets();
        // Textures
        // - ads
        viewer.loadSRGBTexture(
            'ad_wall',
            `draw-animation/textures/${lotterySlug}_ad_wall.jpg`,
            'draw-animation/textures/ad_wall.jpg'
        );

        if (params.tableAdVisible) {
            viewer.loadSRGBTexture(
                'ad_table',
                `draw-animation/textures/${lotterySlug}_ad_table.jpg`,
                'draw-animation/textures/ad_table.jpg'
            );
        }

        // GLTF
        viewer.loadGLTF('scene', `${pathToAssets}/models/BasicStudioScene.glb`);
    }

    static loadModel(viewer, params: SceneParams) {
        viewer.addModel(new SceneAmbientLight(viewer));
        viewer.addModel(new SceneDirectionalLight(viewer));
        viewer.addModel(new BasicStudioSceneGLTF(viewer, viewer.getGLTF('scene'), params));
    }

    meshUpdate(model) {
        switch (model.name) {
            case 'Wall':
                model.material = new THREE.MeshBasicMaterial({
                    map: this.viewer.getTexture('ad_wall'),
                });
                break;
            case 'Table':
                model.material = new THREE.MeshStandardMaterial({
                    color: '#555555',
                    roughness: 1,
                    metalness: 0,
                    side: THREE.FrontSide,
                    envMap: this.viewer.getEnvMap(),
                    envMapIntensity: this.viewer.getEnvMapIntensity(),
                });
                model.receiveShadow = true;
                model.castShadow = true;
                break;
            case 'Floor':
                model.material = new THREE.MeshStandardMaterial({
                    color: '#777777',
                    roughness: 1,
                    metalness: 0,
                    side: THREE.FrontSide,
                    envMap: this.viewer.getEnvMap(),
                    envMapIntensity: this.viewer.getEnvMapIntensity(),
                });
                model.receiveShadow = true;
                model.castShadow = true;
                break;
            case 'TableAd':
                model.visible = this.params.tableAdVisible;
                if (model.visible) {
                    model.material = new THREE.MeshStandardMaterial({
                        map: this.viewer.getTexture('ad_table'),
                        roughness: 1,
                        metalness: 0,
                        side: THREE.FrontSide,
                        envMap: this.viewer.getEnvMap(),
                        envMapIntensity: this.viewer.getEnvMapIntensity(),
                    });
                }
                break;
            default:
                if (!model.name.includes('Position')) throw new Error(`GLTF Model without material: ${model.name}`);
        }
    }

    sceneUpdate(scene) {}

    animationUpdate(animation) {}
}
